module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('a', {
    attrs: {
      "id": "HLD4"
    }
  }), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELCOME TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOL")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("If you have never worked with wool before, you may be surprised at the versatility and beauty that can come from this amazing textile. If you "), _c('i', [_vm._v("have")]), _vm._v(" worked in wool before, I am sure you know what I am referring to. Wool appliqué is a wonderful textile medium that allows the artist to be creative in a different way from paint or pen. It is all about texture, depth, design, and color. It’s also a growing art form, and you can now find many sources for not only inspiration but also materials, which is very important.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Wool will take over your spaces if you are not careful, and it can show up in unexpected closets and cupboards—much to the surprise of your family. Here I will familiarize you with this textile and share my methods for processing wool to obtain a unique look and color. I also include some storage techniques that I have discovered over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I hope this inspires you to think about wool and all of the possibilities for its use.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc1"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOL")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In my wool work I use mostly repurposed wool. I obtain it by going to flea markets, thrift stores, auctions, and yard sales and searching for wool that is really no longer wanted in its current condition but can be processed into something useful. I look for wools that are medium weight, which can be dyed or felted to use in appliqué. These are usually in the form of blankets, skirts, jackets, or even old yardage. Keep an eye out for wools that are plain or only slightly patterned. They are the best to use in appliqué. The other thing to watch for is the color. The lighter the color, the better it is for dyeing or overdyeing.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When buying wool, avoid wool that is too heavy or too light in weight and wool that is loosely woven, because it will fray.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The other option is to buy wool that is already processed from a wool shop or an individual who sells hand-dyed wools. A growing number of sources are available for those of you who would like to start with wool that is ready to go (see "), _c('span', {
    attrs: {
      "href": "#/20_chapter18#HLD25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROCESSING")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOL")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When I use the term "), _c('i', [_vm._v("processing")]), _vm._v(", I am referring to the necessary steps to go from woven wool to felted wool that is ready to use. This usually includes felting and dyeing. I would like to say that I start with a sheep and finish with beautiful woven wool, but that is not the case.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Felting")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Felting is the process of getting the wool to be the right texture for an appliqué project. Some wools felt better than others. The wool fibers must bind together. This keeps the edges from fraying and makes the wool very soft and strong. To felt your wool, follow these three simple steps.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "nsp"
  }, [_vm._v("1")]), _vm._v(" You need a large cooking pot that you will not use for cooking ever again. I recommend this because the commercial dyes are often acid-based. Put in the wool you want to felt and add water to the pot, covering the wool with at least an inch of water.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "nsp"
  }, [_vm._v("2")]), _vm._v(" Bring the water to a boil and let the wool simmer for about 20 minutes. All wool is different, and you will have to see how the differing weaves react when boiled. Let the water cool before removing the wool.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "nsp"
  }, [_vm._v("3")]), _vm._v(" Let the wool drip dry. I drape the wool over a clothesline outside in good weather or hang it over my large wash sink in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This is how I do it, but there are no hard-and-fast rules about felting. You can also throw the wool in the washer and dryer. Both the agitation and heat will felt the woven wool.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Dyeing")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I am not a dyeing expert, but I enjoy the process. When I dye wool, I often use natural dyes. If you want to try your hand using commercial dyes, please read and carefully follow the manufacturer’s instructions (see "), _c('span', {
    attrs: {
      "href": "#/20_chapter18#HLD25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Natural dyeing techniques can be a lot of fun as well. My family appreciates that I do this type of dyeing outdoors because of the smell. I have a three-gallon brass kettle that I use for natural dyes as well as felting, and it works wonderfully. I just play around with whatever I can find in my yard or my friends’ yards and see what I come up with. I’ve used black walnuts, goldenrod, and onionskins.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It can be very satisfying to know that you have had more of a hand in your project. Dyeing is certainly not for everyone. I never dreamed that I would take it up, but, well, here we are.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc3"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORING")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOL")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Now that you have lots of wool ready to go, you need somewhere to keep it. Trust me, you may start out with just a small pile, but it will grow.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("One of my favorite storage options is small plastic bins. The ones I use are clear and roughly 7˝ high, 15˝ long, and 11˝ wide. These are excellent for separating your colors as well as keeping moths out. You can then put the bins in a cupboard, arranged by color, where the wool will be handy and ready for use.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I store bigger wool pieces in a variety of large baskets that I keep in my studio. The baskets are efficient and look nice.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "ttitle"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "",
      "src": "images/fl.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('i', [_vm._v("hint")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "",
      "src": "images/fl1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ttxt"
  }, [_c('i', [_vm._v("Keep lavender or strong-smelling herbs such as sage with your wool to repel moths.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("My favorite way to store wool scraps is to keep them in clear glass storage jars. I use one- to three-gallon jars. With these also you can separate your colors to have just what you need within easy reach. These look great lined up across a shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Glass jars are perfect for storing wool scraps.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a3d3fec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chapter04.vue
// module id = 72
// module chunks = 0